import type { Opportunity } from "@api/opportunity";

export type OpportunityField = keyof Omit<Opportunity, "id" | "category_id">;

export type ColumnDef = {
  field: OpportunityField;
  header: string;
  width: string;
  isDate?: boolean;
};

export type CategoryType = "concert" | "corporate" | "theater";

export function getCategoryType(categoryName: string): CategoryType {
  if (categoryName.startsWith("Corporate Events")) return "corporate";
  if (categoryName.startsWith("Theater")) return "theater";
  return "concert";
}

const CONCERT_COLUMNS: ColumnDef[] = [
  { field: "first_us_date", header: "First Date", width: "11%", isDate: true },
  { field: "artist_tour", header: "Artist/Tour", width: "14%" },
  { field: "ld", header: "LD", width: "10%" },
  { field: "previous_tour_ld", header: "Previous Tour LD", width: "10%" },
  { field: "christie_rep_ld", header: "Christie Rep (LD)", width: "10%" },
  { field: "production_manager", header: "Production Manager", width: "11%" },
  { field: "previous_tour_pm", header: "Previous Tour PM", width: "10%" },
  { field: "christie_rep_pm", header: "Christie Rep (PM)", width: "10%" },
  { field: "band_management", header: "Band Management", width: "10%" },
];

const CORPORATE_COLUMNS: ColumnDef[] = [
  { field: "first_us_date", header: "Date", width: "11%", isDate: true },
  { field: "artist_tour", header: "Corporate Event", width: "16%" },
  { field: "location", header: "Location", width: "11%" },
  { field: "ld", header: "LD", width: "10%" },
  { field: "christie_rep_ld", header: "Christie Rep (LD)", width: "11%" },
  { field: "production_manager", header: "Production Manager", width: "12%" },
  { field: "christie_rep_pm", header: "Christie Rep (PM)", width: "11%" },
  { field: "agency", header: "Agency", width: "11%" },
];

const THEATER_COLUMNS: ColumnDef[] = [
  { field: "first_us_date", header: "First Date", width: "11%", isDate: true },
  { field: "artist_tour", header: "Theater Production", width: "14%" },
  { field: "ld", header: "LD", width: "10%" },
  { field: "previous_tour_ld", header: "Previous Tour LD", width: "10%" },
  { field: "christie_rep_ld", header: "Christie Rep (LD)", width: "10%" },
  { field: "production_manager", header: "Production Manager", width: "11%" },
  { field: "previous_tour_pm", header: "Previous Tour PM", width: "10%" },
  { field: "christie_rep_pm", header: "Christie Rep (PM)", width: "10%" },
  { field: "producer", header: "Producer", width: "10%" },
];

const COLUMNS_MAP: Record<CategoryType, ColumnDef[]> = {
  concert: CONCERT_COLUMNS,
  corporate: CORPORATE_COLUMNS,
  theater: THEATER_COLUMNS,
};

export function getColumnsForCategory(categoryName: string): ColumnDef[] {
  return COLUMNS_MAP[getCategoryType(categoryName)];
}
